// Shared coach-side booking behavior for private lesson slots. Two mixins so
// row-level components can take the checkout links without dragging in the
// status-update state.
//
// Hosts are expected to provide errorableMix (error display) and, when they
// render inside the app embed, appEmbedMix (forAppEmbed / askAppToPush).

export const lessonCheckoutMix = {
  methods: {
    lessonCheckoutHref(privateLessonId) {
      return `/private_lessons/${privateLessonId}/checkout`;
    },
    // In the embed the native app pushes the checkout screen instead of
    // following the web href
    handleLessonCheckoutClick(e, privateLessonId) {
      if (this.forAppEmbed) {
        e.preventDefault();
        this.askAppToPush(`${window.location.origin}/app_embeds/private_lessons/${privateLessonId}/checkout`, 'Checkout');
      }
    },
  },
};

export const privateLessonBookingMix = {
  data() {
    return {
      // Guards confirm/decline against double-taps firing duplicate PUTs
      updatingBookingId: null,
    };
  },
  methods: {
    // PUTs a coach booking's status ('confirmed' | 'declined').
    // actorProfileId is the coach profile recorded as booked_by on
    // confirmation — null for non-coach billing admins, whose confirmations
    // carry no booked_by. Toast and error display are handled here; onSuccess
    // handles the host's own refresh.
    updateCoachBookingStatus({
      coachBookingId, status, actorProfileId, onSuccess,
    }) {
      const vm = this;
      if (vm.updatingBookingId) {
        return;
      }
      vm.updatingBookingId = coachBookingId;
      const params = { event_booking: { status } };
      if (status === 'confirmed') {
        if (actorProfileId) {
          params.event_booking.booked_by_id = actorProfileId;
          params.event_booking.booked_by_type = 'CoachProfile';
        }
        params.event_booking.cancellation_reason = '';
      }
      axios.put(vm.$apiService.eventBookingUrl(coachBookingId), params)
        .then(() => {
          vm.updatingBookingId = null;
          vm.$notificationManager.emit('show-toast', 'Booking updated', true);
          onSuccess();
        })
        .catch((error) => {
          vm.updatingBookingId = null;
          vm.errorMessage = vm.parseErrorResponse(error);
          vm.error = true;
        });
    },
  },
};
